module.exports = __webpack_public_path__ + "static/media/thumb2.32743d97.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/terminology/assets/thumb2.png
// module id = 125
// module chunks = 0